import { render, staticRenderFns } from "./ProTip.vue?vue&type=template&id=50526add&"
import script from "./ProTip.vue?vue&type=script&lang=js&"
export * from "./ProTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports